import { render, staticRenderFns } from "./GoodsCombinationDetails.vue?vue&type=template&id=15bf9c77&scoped=true&"
import script from "./GoodsCombinationDetails.vue?vue&type=script&lang=js&"
export * from "./GoodsCombinationDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCombinationDetails.vue?vue&type=style&index=0&id=15bf9c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf9c77",
  null
  
)

export default component.exports